// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Dlyp","rightAdornment":"Header_rightAdornment__3izuH"};